module.exports = __webpack_public_path__ + "static/media/search-text.c5453c5c.png";